export const USER_QUESTION_CHARACTER_LIMIT = 250;

export const keyPressMap = { Enter: false, Shift: false };

export const FALLBACK_SESSION_ID = 'fallback-sessionId';
export const FALLBACK_USER_ID = 'fallback-userId';

/** Local storage key the assistant keeps its session under. */
export const MAA_SESSION_KEY = 'maa-session';

export const MESSAGE_ORIGIN_PREPOPULATED = 'prepopulated';
export const MESSAGE_ORIGIN_CUSTOM = 'custom';
export const MESSAGE_ORIGIN_UNSPECIFIED = 'unspecified';
export const MESSAGE_ORIGIN_RETRY = 'retry';

export const SUBMIT_ANALYTICS_MAA_PRIMARY_CATEGORY = 'magic apron';
export const IMAGE_UPLOAD_ANALYTICS_EVENT_NAME = 'maa search';
export const ASK_A_QUESTION_ANALYTICS_PLACEHOLDER = 'ask a question clicked';
export const FEEDBACK_ANALYTICS_MAA_PRIMARY_CATEGORY = 'magic apron';
export const FEEDBACK_ANALYTICS_MAA_EVENT_NAME_PREFIX = 'maa feedback';
export const FEEDBACK_ANALYTICS_QNA_PRIMARY_CATEGORY = 'magic apron';
export const FEEDBACK_ANALYTICS_QNA_EVENT_NAME_PREFIX = 'ma qna feedback';
export const FEEDBACK_CLICK_COMMENT_QUESTION_ORIGIN_MAA = 'maa';
export const FEEDBACK_CLICK_COMMENT_QUESTION_ORIGIN_QNA = 'ma qna';
export const FEEDBACK_CLICK_UPLOAD_CAMERA_ATTACHMENT = 'camera upload';
export const FEEDBACK_CLICK_UPLOAD_FILE_ATTACHMENT = 'file upload';
export const FEEDBACK_CLICK_UPLOAD_IMAGE_ATTACHMENT = 'image upload';
export const LIVE_AGENT_ANALYTICS_CONNECTION_STRING = 'lv:connect:session start';
export const LIVE_AGENT_ANALYTICS_DISCONNECTION_STRING = 'lv:disconnect:session end';
export const LIVE_AGENT_ANALYTICS_CUSTOM_MESSAGE_PREFIX = 'lv:custom:';
export const LIVE_AGENT_ANALYTICS_FIRST_MESSAGE_SUFFIX = ':is first message';
export const LIVE_AGENT_ANALYTICS_SURVEY_RECEIVED = 'lv:survey receive';
export const LIVE_AGENT_ANALYTICS_SURVEY_STARTED = 'lv:survey start';

export const RETRY_MESSAGE = {
  type: 'bot',
  content: {
    responseSummary: {
      summaryAnswer: 'The conversation was interrupted before I could finish finding the answer.',
    },
  },
};

// ---------------------------------------------------------------------------
// Live Agent (Sprinklr) constants
// ---------------------------------------------------------------------------
export const AGENT_HANDOFF_KEYWORDS = ['agent', 'associate'];

export const MESSAGE_TYPE_AGENT = 'agent';
export const MESSAGE_TYPE_SYSTEM = 'system';

export const LIVE_AGENT_CONNECTING_MESSAGE = {
  type: 'system',
  variant: 'connecting',
  content: 'Connecting to a live associate',
};

export const LIVE_AGENT_CONNECTED_MESSAGE = {
  type: 'system',
  variant: 'connected',
  content: 'You\'re chatting with an associate',
  dividerText: 'Connected',
};

export const LIVE_AGENT_ENDED_MESSAGE = {
  type: 'system',
  variant: 'ended',
  content: 'You\'re chatting with Magic Apron',
  dividerText: 'Live chat ended',
};

export const LIVE_AGENT_IDLE_DISCONNECTED_MESSAGE = {
  type: 'system',
  variant: 'idle-ended',
  content: 'You\'re chatting with Magic Apron',
  dividerText: 'Live chat ended due to inactivity',
};

export const IDLE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours

export const LIVE_AGENT_ERROR_MESSAGE = {
  type: 'system',
  content: 'Unable to connect to an associate right now. Please try again later.',
};

// Mirrors the PlannerAssistantPageTypeInput enum the planner assistant service
// validates pageContext.pageType against. The casing is part of the contract —
// the service rejects the mutation on a mismatch — so these are the enum's
// exact members, not screaming-case names that happen to read the same.
export const LEGACY_PAGE_TYPES = {
  HOME: 'Home',
  PLP: 'PLP',
  PIP: 'PIP',
  CONTENT: 'Content',
  CART: 'Cart',
  CHECKOUT: 'Checkout',
  SEARCH: 'Search',
  BROWSE: 'Browse',
  BIP: 'BIP',
  UNKNOWN: 'Unknown',
};

export const VALID_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];
export const MAX_FILE_SIZE_MB = 20;

export const UPLOAD_ERROR_MESSAGES = {
  UNSUPPORTED_CONTENT_PROPRIETY: 'This image doesn\'t meet content guidelines. Select a different image and try again.',
  FILE_SIZE_EXCEEDED: `This file is too large. Choose a file ${MAX_FILE_SIZE_MB} MB or less and try again.`,
  UNSUPPORTED_FILE_TYPE: 'This file type is not supported. Please upload a valid file.',
  GENERIC_ERROR: 'Something went wrong with the upload. Try again later.'
};

export const DEFAULT_MESSAGE_HISTORY_CONTAINER_WIDTH = 400;
export const IMAGE_SKELETON_PLACEHOLDER_MAX_WIDTH_PROPORTION = 0.8;
export const IMAGE_SKELETON_PLACEHOLDER_MAX_HEIGHT_PROPORTION = 0.5;
